<template>
  <div class="navType">
    <div class="nav-munu">
      <div class="back" @click="$router.back()"><img src="/imgs/back.png" alt="back" /></div>
      <div class="nav-name">{{ $route.params.type }}</div>
    </div>
    <div class="list-box">
      <p class="all-tag" @click="toList()">All {{ $route.params.type.toUpperCase() }}</p>
      <v-expansion-panels v-model="panelOpen" accordion>
        <v-expansion-panel v-if="list.rim">
          <v-expansion-panel-header>SHOP BY TYPE</v-expansion-panel-header>
          <v-expansion-panel-content eager>
            <div class="expansion-content">
              <p v-for="item in list.rim" :key="item.id" class="item-line" @click="toList('rim', item.id)">{{ item.name }}</p>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-if="list.material">
          <v-expansion-panel-header>SHOP BY MATERIAL</v-expansion-panel-header>
          <v-expansion-panel-content eager>
            <div class="expansion-content">
              <p v-for="item in list.material" :key="item.id" class="item-line" @click="toList('material', item.id)">{{ item.name }}</p>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-if="list.color">
          <v-expansion-panel-header>SHOP BY COLOR</v-expansion-panel-header>
          <v-expansion-panel-content eager>
            <div class="expansion-content">
              <div class="color-box">
                <div v-for="item in list.color" :key="item.id" class="color-list" @click="toList('color', item.id)">
                  <p class="color-item">
                    <span class="color-text" :style="{ background: `url(${item.icon})` }"></span>
                  </p>
                  <p class="right">{{ item.name }}</p>
                </div>
              </div>

              <!-- <p v-for="item in list.color" :key="item.id" class="item-line">{{ item.name }}</p> -->
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-if="list.shape">
          <v-expansion-panel-header>SHOP BY SHAPE</v-expansion-panel-header>
          <v-expansion-panel-content eager>
            <div class="expansion-content">
              <p v-for="item in list.shape" :key="item.id" class="item-line" @click="toList('shape', item.id)">{{ item.name }}</p>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <div v-if="list.genders" class="img-type">
        <div v-for="item in list.genders" :key="item.id" class="img-list" @click="toList('genders', item.id)">
          <img :src="`/imgs/${renderImg(item.name)}`" :alt="item.name" />
          <p>{{ item.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navType',
  data() {
    return {
      panelOpen: undefined,
      list: {}
    }
  },
  computed: {
    renderImg() {
      return function (type) {
        if (type === 'Men') {
          return 'icon-men.png'
        } else if (type === 'Women') {
          return 'icon-women.png'
        } else if (type === 'Kids') {
          return 'icon-kids.png'
        }
      }
    }
  },
  mounted() {
    this.getType()
  },
  methods: {
    toList(type, id) {
      let typeTop = ''
      if (this.$route.params.type === 'Eyeglasses') {
        typeTop = 'eyeglasses'
      } else if (this.$route.params.type === 'Sunglasses') {
        typeTop = 'sunglasses'
      } else {
        typeTop = this.$route.params.type
      }
      if (type) {
        const query = {}
        const filter = encodeURI(JSON.stringify({ [type]: [id] }))
        query.filter = filter
        this.$router.push({
          name: 'search-type',
          params: {
            type: typeTop
          },
          query
        })
        // this.$router.push({
        //   name: 'search-type',
        //   params: {
        //     type: typeTop
        //   },
        //   query: {
        //     cut: type,
        //     id
        //   }
        // })
      } else {
        this.$router.push({
          name: 'search-type',
          params: {
            type: typeTop
          }
        })
      }
    },
    async getType() {
      const { data: typeList } = await this.$api.system.getGoodsType({
        type: 'All'
      })
      this.list = typeList
    }
  }
}
</script>

<style lang="scss" scoped>
.navType {
  min-height: 100vh;
  margin-top: 57px;
  background: linear-gradient(160deg, #f5f7fb 0%, #eef1f8 30%, #f8f9fc 60%, #f0f3fa 100%);
  .nav-munu {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 64px;
    padding: 0 10px;
    position: sticky;
    top: 0;
    z-index: 10;
    background: rgba(255, 255, 255, 0.72);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-bottom: 1px solid rgba(48, 103, 242, 0.08);
    box-shadow: 0 1px 20px rgba(48, 103, 242, 0.04);
    .back {
      position: absolute;
      left: 18px;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      transition: background 0.25s ease;
      &:hover {
        background: rgba(48, 103, 242, 0.06);
      }
      &:active {
        background: rgba(48, 103, 242, 0.1);
      }
      img {
        width: 10px;
        height: 18px;
      }
    }
    .nav-name {
      text-align: center;
      font-size: 17px;
      font-weight: 600;
      color: #1a1d2e;
      line-height: 20px;
      letter-spacing: 1px;
    }
  }
  .list-box {
    padding: 16px 16px 0;
  }
  .all-tag {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 12px;
    padding: 14px 20px;
    text-align: left;
    color: #3067f2;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border-radius: 14px;
    border: 1px solid rgba(48, 103, 242, 0.1);
    box-shadow: 0 2px 12px rgba(48, 103, 242, 0.04), 0 1px 3px rgba(0, 0, 0, 0.02);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    &:hover {
      background: rgba(255, 255, 255, 0.95);
      box-shadow: 0 4px 20px rgba(48, 103, 242, 0.1);
    }
  }
  ::v-deep .v-expansion-panels {
    border-radius: 14px;
    overflow: hidden;
    gap: 2px;
    background: transparent;
    .v-expansion-panel {
      background: rgba(255, 255, 255, 0.72);
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
      border: 1px solid rgba(48, 103, 242, 0.06);
      box-shadow: 0 2px 12px rgba(48, 103, 242, 0.03);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      &:not(:first-child) {
        border-top: 1px solid rgba(48, 103, 242, 0.06);
      }
      &::before {
        box-shadow: none;
      }
      &.v-expansion-panel--active {
        box-shadow: 0 4px 20px rgba(48, 103, 242, 0.08);
        border-color: rgba(48, 103, 242, 0.12);
      }
      &:first-child {
        border-radius: 14px 14px 0 0;
      }
      &:last-child {
        border-radius: 0 0 14px 14px;
      }
    }
    .v-expansion-panel-header {
      padding: 0 20px;
      height: 52px;
      font-size: 14px;
      font-weight: 600;
      color: #3a3f51;
      letter-spacing: 0.5px;
    }
    .v-expansion-panel-header--active {
      color: #3067f2;
    }
    .v-expansion-panel-content__wrap {
      padding: 0 20px 12px;
    }
    .v-expansion-panel-content {
      .v-expansion-panel-content__wrap {
        padding: 0 20px 16px;
      }
    }
  }
  .item-line {
    height: 48px;
    line-height: 48px;
    border-bottom: 1px solid rgba(48, 103, 242, 0.06);
    font-size: 14px;
    font-weight: 400;
    color: #525861;
    margin-bottom: 0;
    padding: 0 4px;
    cursor: pointer;
    transition: color 0.2s ease, padding-left 0.2s ease;
    &:last-child {
      border-bottom: none;
    }
    &:hover {
      color: #3067f2;
      padding-left: 8px;
    }
  }
  .color-box {
    display: flex;
    flex-wrap: wrap;
  }
  .color-list {
    display: flex;
    width: 50%;
    align-items: center;
    margin-bottom: 10px;
    cursor: pointer;
    padding: 6px 4px;
    border-radius: 10px;
    transition: background 0.2s ease;
    &:hover {
      background: rgba(48, 103, 242, 0.04);
    }
    .right {
      margin-bottom: 0;
      color: #525861;
      font-size: 13px;
      font-weight: 500;
    }
  }
  .color-item {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    padding: 3px;
    margin-right: 8px;
    margin-bottom: 0;
    border-radius: 50%;
    cursor: pointer;
    border: 3px solid #e7e7e7;
    transition: border-color 0.2s ease;
  }
  .color-list:hover .color-item {
    border-color: #3067f2;
  }
  .color-text {
    display: inline-block;
    border-radius: 50%;
    width: 100%;
    height: 100%;
  }
  .img-type {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin-top: 24px;
    padding: 0 4px 24px;
    .img-list {
      text-align: center;
      cursor: pointer;
      img {
        width: 100px;
        height: 100px;
        margin-bottom: 8px;
        transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      }
      &:hover img {
        transform: scale(1.06);
      }
      p {
        color: #fff;
        margin-bottom: 0;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0.3px;
      }
      &:nth-child(1) p {
        text-shadow: 0px 0px 1px #3067f2, 2px 2px 2px #3067f2, -2px 2px 4px #3067f2, 3px -1px 4px #3067f2, 3px 3px 2px #3067f2, -1px -2px 2px #3067f2, 3px 3px 2px #3067f2;
      }
      &:nth-child(2) p {
        text-shadow: 0px 0px 1px #ffc600, 2px 2px 2px #ffc600, -2px 2px 4px #ffc600, 3px -1px 4px #ffc600, 3px 3px 2px #ffc600, -1px -2px 2px #ffc600, 3px 3px 2px #ffc600;
      }
      &:nth-child(3) p {
        text-shadow: 0px 0px 1px #28ad00, 2px 2px 2px #28ad00, -2px 2px 4px #28ad00, 3px -1px 4px #28ad00, 3px 3px 2px #28ad00, -1px -2px 2px #28ad00, 3px 3px 2px #28ad00;
      }
    }
  }
}
</style>
